import { useForm } from 'react-hook-form';
import Button from 'src/components/atoms/button/button';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Modal from 'src/components/atoms/modal/modal';
import Spinner from 'src/components/atoms/spinner/spinner';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { createNewRole } from 'src/reducers/roles.reducer';
import { validationSchema } from 'src/utils/validation-utils';

export const ProfilesAndAuthorizationsCreate = () => {
  const dispatch = useAppDispatch();

  const {
    register,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { name: '' },
  });

  const { createLoading } = useAppSelector(state => state.roles);

  const saveNewProfile = data => {
    dispatch(createNewRole({ name: data.name }));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <Form>
          <FormRow>
            <FormItem>
              <label>Nome del profilo</label>
              <input
                required
                autoComplete="off"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                type="text"
                placeholder="Nome del profilo"
                {...register('name', validationSchema.required)}
              />
              <FormError error={errors.name} validation={validationSchema.required} />
            </FormItem>
          </FormRow>

          <FormRow>
            <Button
              onClick={() => saveNewProfile(getValues())}
              disabled={!isValid || createLoading}
              size="md"
              color="white"
              mode="outline"
              rounded="rounded-md"
            >
              {createLoading ? <Spinner /> : 'Crea ruolo'}
            </Button>
          </FormRow>
        </Form>
      </Modal.Body>
    </>
  );
};
